import type { BadgeKanbanStageStatusColor } from '@shared/ui/kanban'

import { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

export const TUTOR_KANBAN_STAGE_COLOR: Record<TutorKanbanStage, BadgeKanbanStageStatusColor> = {
  [TutorKanbanStage.AccountActivated]: 'blue',
  [TutorKanbanStage.AccountCreated]: 'blue',
  [TutorKanbanStage.AwaitingFirstLesson]: 'blue',
  [TutorKanbanStage.Dropped]: 'gray',
  [TutorKanbanStage.ExitDecisionRequest]: 'orange',
  [TutorKanbanStage.ExitFinished]: 'gray',
  [TutorKanbanStage.ExitInProgress]: 'blue',
  [TutorKanbanStage.Monitoring]: 'blue',
  [TutorKanbanStage.NeedsAttention]: 'orange',
  [TutorKanbanStage.NeedsCheck]: 'orange',
  [TutorKanbanStage.PracticeInvited]: 'blue',
  [TutorKanbanStage.PracticeOngoing]: 'blue',
  [TutorKanbanStage.PracticePassed]: 'emerald',
  [TutorKanbanStage.PracticeScheduled]: 'blue',
  [TutorKanbanStage.ProbationFailed]: 'gray',
  [TutorKanbanStage.ProbationInProgress]: 'blue',
  [TutorKanbanStage.RegularDemoTutor]: 'blue',
  [TutorKanbanStage.RegularTutor]: 'blue',
  [TutorKanbanStage.TimeOff]: 'blue',
  [TutorKanbanStage.TopTutor]: 'blue',
  [TutorKanbanStage.UnderReview]: 'blue',
}
